import { __rest } from '../../../../../../_virtual/_tslib.js';
import React, { useContext, useEffect } from 'react';
import { StyledNavbarAdditionalItems } from './Navbar.styles.js';
import { NavbarContext } from './NavbarContext.js';

const NavbarAdditionalItems = (_a) => {
    var { children, dataLwtId = 'navbar-additional-items' } = _a, rest = __rest(_a, ["children", "dataLwtId"]);
    const { isDark, navItems, hasBody, setHasAdditionalNavItems } = useContext(NavbarContext);
    useEffect(() => {
        setHasAdditionalNavItems(true);
    }, []);
    return (React.createElement(StyledNavbarAdditionalItems, Object.assign({ "$isDark": isDark, className: 'helix-unified-nav__additional-items', "data-lwt-id": dataLwtId, "$hasNavItems": navItems.length > 0 || hasBody }, rest),
        React.createElement(React.Fragment, null, children)));
};
NavbarAdditionalItems.displayName = 'NavbarAdditionalItems';

export { NavbarAdditionalItems as default };
//# sourceMappingURL=NavbarAdditionalItems.js.map
